module.exports = __webpack_public_path__ + "img/yinle.f280a8cb.png";